<template>
  <div
    class="a-stat"
    :style="{ '--accent': color, '--accent-soft': soft }"
  >
    <div class="a-stat__icon">
      <feather-icon
        :icon="icon"
        size="22"
      />
    </div>
    <div class="a-stat__body">
      <span class="a-stat__label">{{ label }}</span>
      <span class="a-stat__value">{{ formatted }}</span>
      <span
        v-if="hint"
        class="a-stat__hint"
      >{{ hint }}</span>
    </div>
  </div>
</template>

<script>
import { tint, formatNumber } from './analysisTheme'

export default {
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], default: 0 },
    icon: { type: String, default: 'BarChart2Icon' },
    color: { type: String, default: '#1c84f2' },
    hint: { type: String, default: '' },
  },
  computed: {
    soft() {
      return tint(this.color, 0.13)
    },
    formatted() {
      return formatNumber(this.value)
    },
  },
}
</script>

<style lang="scss" scoped>
.a-stat {
  display: flex;
  align-items: center;
  gap: 14px;
  height: 100%;
  padding: 16px 18px;
  background: #eef4fb;
  border: 1px solid #d5e2f2;
  border-radius: 14px;
  border-left: 4px solid var(--accent);
  box-shadow: 0 2px 10px rgba(31, 45, 61, 0.04);
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(31, 45, 61, 0.08);
  }

  &__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 46px;
    height: 46px;
    border-radius: 12px;
    color: var(--accent);
    background: var(--accent-soft);
  }

  &__body {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &__label {
    font-size: 0.78rem;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #6b7a90;
  }

  &__value {
    font-size: 1.6rem;
    font-weight: 700;
    line-height: 1.2;
    color: #1d2b44;
  }

  &__hint {
    font-size: 0.75rem;
    color: #6b7a90;
  }
}
</style>
